import termsV1Text from '../../../docs/legal/host-analytics-terms-v1.md?raw'

export interface PublishedHostAnalyticsTerms {
  version: string
  effectiveDate: string
  path: string
  text: string
}

/** One canonical publication per server terms version. */
export const PUBLISHED_HOST_ANALYTICS_TERMS = [
  {
    version: 'host-analytics-v1',
    effectiveDate: '2026-09-03',
    path: '/legal/host-analytics/host-analytics-v1',
    text: termsV1Text,
  },
] as const satisfies readonly PublishedHostAnalyticsTerms[]

export function publishedHostAnalyticsTerms(version: string) {
  return PUBLISHED_HOST_ANALYTICS_TERMS.find(
    (candidate) => candidate.version === version,
  )
}
